import React from "react";
import { FormItem, InputItem, SelectItem } from "../../../Components/Items";

const CamposMasterBiwo = ({ masters = [] }) => (
    <>
        <FormItem label="Master" name="tipoMaster" initialValue="existente" margin>
            <SelectItem options={[{ value: "existente", label: "Master existente" }, { value: "nuevo", label: "Crear master nuevo" }]} />
        </FormItem>
        <FormItem noStyle shouldUpdate={(a, b) => a.tipoMaster !== b.tipoMaster}>
            {({ getFieldValue }) =>
                getFieldValue("tipoMaster") === "nuevo" ? (
                    <>
                        <FormItem label="Nombre" name="masterNombre" required margin><InputItem placeholder="Nombre" /></FormItem>
                        <FormItem label="Apellido paterno" name="masterApellidoPaterno" required margin><InputItem placeholder="Apellido paterno" /></FormItem>
                        <FormItem label="Apellido materno" name="masterApellidoMaterno" required margin><InputItem placeholder="Apellido materno" /></FormItem>
                        <FormItem label="Corporativo" name="masterNombreCorporativo" margin><InputItem placeholder="Nombre corporativo" /></FormItem>
                        <FormItem label="Nombre de usuario" name="masterNombreUsuario" required margin><InputItem placeholder="Nombre de usuario" /></FormItem>
                        <FormItem label="Correo" name="masterCorreo" required email margin><InputItem placeholder="Correo" /></FormItem>
                        <FormItem label="Contraseña" name="masterPassword" required min={5} max={200} margin><InputItem type="password" placeholder="Contraseña" /></FormItem>
                    </>
                ) : (
                    <FormItem label="Master" name="masterId" required margin>
                        <SelectItem showSearch optionFilterProp="label" placeholder="Buscar master" options={masters.map((m) => ({ value: m._id, label: m.nombre }))} />
                    </FormItem>
                )
            }
        </FormItem>
    </>
);

export default CamposMasterBiwo;
